import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import {
  CondominiumPaymentDTO,
  CondominiumService
} from '../../services/condominium.service';

@Component({
  selector: 'app-condominium-payments',
  standalone: false,
  templateUrl: './condominium-payments.component.html',
  styleUrl: './condominium-payments.component.sass'
})
export class CondominiumPaymentsComponent implements OnInit {
  condominiumId?: number;
  payments: CondominiumPaymentDTO[] = [];
  displayedColumns: string[] = [
    'paymentId',
    'status',
    'dueDate',
    'paymentDate',
    'value',
    'paymentLink'
  ];
  totalElements = 0;
  pageIndex = 0;
  pageSize = 10;
  isLoading = true;
  accessDenied = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private condominiumService: CondominiumService
  ) {}

  async ngOnInit(): Promise<void> {
    const idParam = this.route.parent?.snapshot.paramMap.get('id');
    const id = idParam ? Number(idParam) : NaN;
    if (isNaN(id)) {
      this.isLoading = false;
      void this.router.navigate(['/condominiums']);
      return;
    }
    this.condominiumId = id;
    const isOwner = await this.condominiumService.isCurrentUserOwnerOfCondominium(id);
    if (!isOwner) {
      this.accessDenied = true;
      this.isLoading = false;
      void this.router.navigate(['/condominiums']);
      return;
    }
    this.loadPayments();
  }

  loadPayments(options?: { silent?: boolean }): void {
    if (!this.condominiumId) {
      return;
    }
    if (!options?.silent) {
      this.isLoading = true;
    }
    this.condominiumService
      .getCondominiumPayments(this.condominiumId, this.pageIndex, this.pageSize)
      .subscribe({
        next: (page) => {
          this.payments = page.content ?? [];
          this.totalElements = page.totalElements ?? 0;
          this.isLoading = false;
        },
        error: () => {
          this.payments = [];
          this.totalElements = 0;
          this.isLoading = false;
        }
      });
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadPayments({ silent: true });
  }

  paymentStatusLabel(status: string | undefined): string {
    if (status == null || status === '') {
      return 'Desconhecido';
    }
    const normalized = status.trim().toUpperCase();
    if (normalized === 'PENDING' || normalized === 'RECEIVED') {
      return 'Pendente';
    }
    if (normalized === 'CONFIRMED') {
      return 'Pago';
    }
    if (normalized === 'OVERDUE') {
      return 'Atrasado';
    }
    return 'Desconhecido';
  }
}
